module.exports = __webpack_public_path__ + "9764d53dd9682fbb4b42540a2678d4ba.pdf";